import { useEffect, useRef, useState } from "react";
import Header from "../Sharedcomponents/Header/Header";
import "../BookyourSlot/SlotPage.scss";
import featherImage from "../assets/feather.png";
import { AiOutlineInstagram } from "react-icons/ai";
import { FaXTwitter } from "react-icons/fa6";
import { SlSocialFacebook } from "react-icons/sl";
import { Calendar } from "primereact/calendar";
import { InputNumber } from "primereact/inputnumber";
import { MdArrowDropUp } from "react-icons/md";
import { MdArrowDropDown } from "react-icons/md";
import ConfirmBook from "./ConfirmBooking/ConfirmBook";
import Footer from "../Component/Footer";
import axios from "axios";
import { getPrice, getSpecificourt } from "../Services/BackendUrl";
import { BsDot } from "react-icons/bs";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";

const SlotPage = () => {
  const [playerCount, setPlayerCount] = useState(1);
  const [date, setDate] = useState(new Date());
  const [dateSelected, setDateselected] = useState(null);
  const [selectdate, setSelectDate] = useState(null);
  const [startTime, setStartTime] = useState("");
  const calendarRef = useRef(null);
  const [selectedCourt, setSelectedCourt] = useState(null);
  const [priceDetails, setPriceDetails] = useState();
  const [court, setCourt] = useState([]);
  const [checkingAvailability, setCheckingAvailability] = useState(false);
  const formatDate = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const currentDate = formatDate(new Date());
  const currentLocalString = new Date().toDateString()
  const localStringValue = currentLocalString.split(" ").slice(1).join(" ")
  const [nextTime, setNextTime] = useState(null);
  const toast = useRef(null);

  const [rangeSelection, setRangeSelection] = useState({
    courtId: null,
    startSlotIndex: null,
    startTime: null,
    availableSlots: []
  });
  const [selectedSlots, setSelectedSlots] = useState([]);

  const getSlotIndex = (courtId, time) => {
    const courtData = court.find(c => c.courts?.some(court => court.courtId === courtId));
    if (!courtData) return 0;
    
    const specificCourt = courtData.courts.find(c => c.courtId === courtId);
    if (!specificCourt) return 0;

    const timeToNum = (timeStr) => {
      if (timeStr === "11:00PM") return 24 * 60; 
      let [hour] = timeStr.split(":");
      const isPM = timeStr.toLowerCase().includes("pm");
      hour = parseInt(hour);
      if (hour === 12) hour = isPM ? 12 : 0;
      else if (isPM) hour += 12;
      return hour * 60;
    };

    const sortedSlots = Object.entries(specificCourt.slots)
      .sort((a, b) => timeToNum(a[1].time) - timeToNum(b[1].time))
      .filter(([_, s]) => {
        const t = timeToNum(s.time);
        return t >= 5 * 60 && t <= 24 * 60;
      });

    return sortedSlots.findIndex(([_, slot]) => slot.time === time);
  };

  // Get all slots for a court in sorted order
  const getSortedSlotsForCourt = (courtId) => {
    const courtData = court.find(c => c.courts?.some(court => court.courtId === courtId));
    if (!courtData) return [];
    
    const specificCourt = courtData.courts.find(c => c.courtId === courtId);
    if (!specificCourt) return [];

    const timeToNum = (timeStr) => {
      if (timeStr === "11:00PM") return 24 * 60; 
      let [hour] = timeStr.split(":");
      const isPM = timeStr.toLowerCase().includes("pm");
      hour = parseInt(hour);
      if (hour === 12) hour = isPM ? 12 : 0;
      else if (isPM) hour += 12;
      return hour * 60;
    };

    return Object.entries(specificCourt.slots)
      .sort((a, b) => timeToNum(a[1].time) - timeToNum(b[1].time))
      .filter(([_, s]) => {
        const t = timeToNum(s.time);
        return t >= 5 * 60 && t <= 24 * 60;
      });
  };

  const getAvailableConsecutiveSlots = (courtId, startSlotIndex) => {
    const sortedSlots = getSortedSlotsForCourt(courtId);
    const availableSlots = [];

    for (let i = startSlotIndex; i < sortedSlots.length; i++) {
      const slot = sortedSlots[i][1];
      if (slot.status === "available") {
        availableSlots.push(i);
      } else {
        break;
      }
    }
    
    return availableSlots;
  };

  const handleSelectSlot = (courtId, time) => {
    const slotIndex = getSlotIndex(courtId, time);
    const sortedSlots = getSortedSlotsForCourt(courtId);
    const slotKey = `${courtId}-${time}`;

    const isStartSlot = rangeSelection.startTime === time && rangeSelection.courtId === courtId;

    if (isStartSlot) {
      setSelectedSlots([]);
      setRangeSelection({
        courtId: null,
        startSlotIndex: null,
        startTime: null,
        availableSlots: []
      });
      return;
    }

    if (!rangeSelection.courtId || rangeSelection.courtId !== courtId) {
      const availableSlots = getAvailableConsecutiveSlots(courtId, slotIndex);
      
      setRangeSelection({
        courtId,
        startSlotIndex: slotIndex,
        startTime: time,
        availableSlots
      });

      const nextTime = sortedSlots[slotIndex + 1]?.[1]?.time || "12:00AM";
      setSelectedSlots([{
        key: slotKey,
        courtId,
        startTime: time,
        endTime: nextTime,
        slotIndex: slotIndex
      }]);
    } 
    else if (rangeSelection.availableSlots.includes(slotIndex)) {
      const startIndex = rangeSelection.startSlotIndex;
      const endIndex = slotIndex;
      const newSlots = [];
      for (let i = startIndex; i <= endIndex; i++) {
        if (rangeSelection.availableSlots.includes(i)) {
          const slotTime = sortedSlots[i][1].time;
          const nextTime = sortedSlots[i + 1]?.[1]?.time || "12:00AM";
          newSlots.push({
            key: `${courtId}-${slotTime}`,
            courtId,
            startTime: slotTime,
            endTime: nextTime,
            slotIndex: i
          });
        }
      }
      
      setSelectedSlots(newSlots);

      setRangeSelection(prev => ({
        ...prev,
        availableSlots: getAvailableConsecutiveSlots(courtId, startIndex)
      }));
    }
    else if (rangeSelection.courtId === courtId && !rangeSelection.availableSlots.includes(slotIndex)) {
      const availableSlots = getAvailableConsecutiveSlots(courtId, slotIndex);
      
      setRangeSelection({
        courtId,
        startSlotIndex: slotIndex,
        startTime: time,
        availableSlots
      });
      const nextTime = sortedSlots[slotIndex + 1]?.[1]?.time || "12:00AM";
      setSelectedSlots([{
        key: slotKey,
        courtId,
        startTime: time,
        endTime: nextTime,
        slotIndex: slotIndex
      }]);
    }
  };

  const isSlotDisabled = (courtId, time) => {
    const slotIndex = getSlotIndex(courtId, time);
    const sortedSlots = getSortedSlotsForCourt(courtId);
    const slot = sortedSlots[slotIndex]?.[1];

    if (slot?.status === "booked") {
      return true;
    }

    if (!rangeSelection.courtId || rangeSelection.courtId !== courtId) {
      return false;
    }

    return !rangeSelection.availableSlots.includes(slotIndex);
  };

  const isSlotSelected = (courtId, time) => {
    const slotKey = `${courtId}-${time}`;
    return selectedSlots.some(slot => slot.key === slotKey);
  };

  const isSlotInAvailableRange = (courtId, time) => {
    if (!rangeSelection.courtId || rangeSelection.courtId !== courtId) {
      return false;
    }
    const slotIndex = getSlotIndex(courtId, time);
    return rangeSelection.availableSlots.includes(slotIndex);
  };

  const isStartSlot = (courtId, time) => {
    return rangeSelection.startTime === time && rangeSelection.courtId === courtId;
  };

  const handleBookSlot = (courtId) => {
    const courtSlots = selectedSlots.filter(slot => slot.courtId === courtId);
    
    if (courtSlots.length === 0) {
      showError("Please select at least one time slot");
      return;
    }

    const sortedSlots = [...courtSlots].sort((a, b) => a.slotIndex - b.slotIndex);
    const firstSlot = sortedSlots[0];
    const lastSlot = sortedSlots[sortedSlots.length - 1];

    setSelectedCourt(courtId);
    setStartTime(firstSlot.startTime);
    setNextTime(lastSlot.endTime);
  };

  const showError = (message) => {
    if (toast.current) {
      toast.current.show({
        severity: 'error',
        summary: 'Booking Error',
        detail: message,
        life: 5000
      });
    }
  };

  const resetBookingState = () => {
    setPlayerCount(1);
    setDate(new Date());
    setSelectDate(new Date());
    setDateselected(null);
    setSelectedSlots([]);
    setRangeSelection({
      courtId: null,
      startSlotIndex: null,
      startTime: null,
      availableSlots: []
    });
  };

  function getDayAndDate(baseDate, daysToAdd = 0) {
    const dateObj = new Date(baseDate);
    dateObj.setDate(dateObj.getDate() + daysToAdd);
    const date = dateObj.getDate();
    const dayShort = dateObj
      .toLocaleDateString("en-US", { weekday: "short" })
      .toUpperCase();
    return `${date} ${dayShort}`;
  }

  const min = 1;
  const max = 100;

  const handleIncrement = () => {
    if (playerCount < max) setPlayerCount((prev) => prev + 1);
  };

  const handleDecrement = () => {
    if (playerCount > min) setPlayerCount((prev) => prev - 1);
  };

  const handleShowCourt = async () => {
    try {
      setCheckingAvailability(true);
      const dateParam = formatDate(selectdate ?? new Date());
      const response = await axios.get(getSpecificourt, {
        params: { date: dateParam },
      });
      const newData = response.data.data;
      console.log(newData)
      setCourt(newData);
      setSelectedSlots([]);
      setRangeSelection({
        courtId: null,
        startSlotIndex: null,
        startTime: null,
        availableSlots: []
      });
    } catch (error) {
      console.error("Error fetching available slot:", error);
      toast.current?.show({
        severity: "error",
        summary: "Availability Error",
        detail: "Failed to check availability. Please try again.",
        life: 5000
      });
    } finally {
      setCheckingAvailability(false);
    }
  };

  useEffect(() => {
    axios
      .get(getSpecificourt, {
        params: {
          date: currentDate
        },
      })
      .then((response) => {
        const newData = response.data.data
        setCourt(newData);
      });
  }, [currentDate]);

  useEffect(() => {
    const fetchPriceData = async () => {
      try {
        const response = await axios.get(getPrice);
        setPriceDetails(response.data.price);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchPriceData();
  }, [nextTime]);

  const calculateSlotPrice = (startTimeStr, endTimeStr, ratePerHour) => {
    const toMinutes = (timeStr) => {
      const [time, meridian] = timeStr.split(/(?=[AP]M)/);
      let [hours, minutes] = time.split(":").map(Number);
      if (timeStr === "12:00AM") return 24 * 60;
      if (meridian === "AM" && hours === 12) hours = 0;
      if (meridian === "PM" && hours < 12) hours += 12;
      return hours * 60 + minutes;
    };

    let startMinutes = toMinutes(startTimeStr);
    let endMinutes = toMinutes(endTimeStr);
    if (endMinutes <= startMinutes) {
      endMinutes += 24 * 60;
    }

    const diffHours = (endMinutes - startMinutes) / 60;
    return diffHours * Number(ratePerHour || 0);
  };

  const calanderChange = (e) => {
    const selected = new Date(e.value);
    setDate(selected);
    setSelectDate(selected);
    const today = new Date(selected);
    today.setHours(0, 0, 0, 0);
    selected.setHours(0, 0, 0, 0);

    let matchedIndex = null;
    for (let i = 0; i < 5; i++) {
      const compareDate = new Date(today);
      compareDate.setDate(today.getDate() + i);
      if (compareDate.getTime() === selected.getTime()) {
        matchedIndex = i;
        break;
      }
    }
    setDateselected(matchedIndex);
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className={ selectedCourt ? "blur" : ""}>
        <Header />
        <div className="book-slot-container">
          <div
            className="small-text left-to-right"
            style={{ fontSize: "2rem", color: "white" }}
          >
            Built For Badminton <span style={{ color: "orange" }}>.</span>
          </div>
          <div
            className="center-text right-to-left"
            style={{ fontSize: "12rem" }}
          >
            GAME ON
          </div>
          <div style={{ position: "absolute", left: "30px" }}>
            {" "}
            <div
              className="media-icon"
              style={{ display: "flex", flexDirection: "column", gap: "40px" }}
            >
              <div>
                <a style={{color:'white'}} href="https://www.instagram.com/kosmos_sports_oman/?hl=en" target="_blank" rel="noreferrer">
                <AiOutlineInstagram size={30} />
                </a>{" "}
              </div>{" "}
              <div>
                <FaXTwitter size={30} />
              </div>{" "}
              <div>
                <a style={{color:'white'}} href="https://www.facebook.com/share/19Gck9kD7a/?mibextid=wwXIfr" target="_blank" rel="noreferrer">
                <SlSocialFacebook size={30} />
                </a>
              </div>
            </div>
            <div className="scroll-text-slot">
              <div
                style={{
                  writingMode: "sideways-lr",
                  fontSize: "0.7rem",
                  color: "white",
                  letterSpacing: "2px",
                }}
              >
                Scroll Down
              </div>
              <div
                style={{
                  borderRight: "2px solid white",
                  paddingBottom: "20px",
                  margin: "10px 0px 0px 7px",
                  writingMode: "vertical-lr",
                  height: "100px",
                }}
              ></div>
            </div>
          </div>
          <img
            src={featherImage}
            alt="FeatherImage"
            className="feather-image up-to-down"
            style={{ position: "absolute" }}
            width={450}
          />
          <div
            className="form-style responsiveless"
            style={{ display: "flex", gap: "20px" }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {" "}
              BOOK A SLOT
            </div>
            <div
              className="form-boxes"
              style={{ display: "flex", flexDirection: "column", gap: "30px" }}
            >
              <div className="form-first-row">
                <div
                  className="slot-border monthselecter justify-center p-0"
                >
                  <Calendar
                    ref={calendarRef}
                    value={selectdate}
                    onChange={(e) => calanderChange(e)}
                    dateFormat="M dd yy"
                    minDate={new Date()}
                    placeholder={localStringValue}
                    readOnlyInput
                    showIcon
                  />
                </div>
                <div className="slot-border justify-center p-0">
                  <div style={{ display: "flex",gap:'30px', alignItems: "center" }}  className="player-count">
                    PLAYER COUNT
                    <InputNumber
                      value={playerCount}
                      onValueChange={(e) => setPlayerCount(e.value)}
                      mode="decimal"
                      min={min}
                      max={max}
                      readOnlyInput
                      style={{
                      width: "5px",
                      }}
                    />
                    <div
                      className="form-down-arrow"
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <MdArrowDropUp
                        size={30}
                        style={{ marginBottom: "4px", cursor: "pointer" }}
                        onClick={handleIncrement}
                      />
                      <MdArrowDropDown
                        size={30}
                        style={{ marginTop: "-15px", cursor: "pointer" }}
                        onClick={handleDecrement}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="form-second-row"
                style={{ display: "flex", gap: "24px" }}
              >
                <div
                  onClick={() => {
                    setDateselected(0);
                    const d = new Date(date);
                    d.setDate(d.getDate() + 0);
                    setSelectDate(d);
                  }}
                  className={`date-border1 ${dateSelected === 0 ? "dateSelected" : ""
                    }`}
                >
                  {" "}
                  {getDayAndDate(date, 0)}
                </div>
                <div
                  onClick={() => {
                    setDateselected(1);
                    const d = new Date(date);
                    d.setDate(d.getDate() + 1);
                    setSelectDate(d);
                  }}
                  className={`date-border ${dateSelected === 1 ? "dateSelected" : ""
                    }`}
                >
                  {" "}
                  {getDayAndDate(date, 1)}
                </div>
                <div
                  onClick={() => {
                    setDateselected(2);
                    const d = new Date(date);
                    d.setDate(d.getDate() + 2);
                    setSelectDate(d);
                  }}
                  className={`date-border ${dateSelected === 2 ? "dateSelected" : ""
                    }`}
                >
                  {" "}
                  {getDayAndDate(date, 2)}{" "}
                </div>
                <div
                  onClick={() => {
                    setDateselected(3);
                    const d = new Date(date);
                    d.setDate(d.getDate() + 3);
                    setSelectDate(d);
                  }}
                  className={`date-border ${dateSelected === 3 ? "dateSelected" : ""
                    }`}
                >
                  {" "}
                  {getDayAndDate(date, 3)}
                </div>
                <div
                  onClick={() => {
                    setDateselected(4);
                    const d = new Date(date);
                    d.setDate(d.getDate() + 4);
                    setSelectDate(d);
                  }}
                  className={`date-border ${dateSelected === 4 ? "dateSelected" : ""
                    }`}
                >
                  {" "}
                  {getDayAndDate(date, 4)}{" "}
                </div>
                <div
                  className="vertical-line"
                  style={{
                    borderRight: "2px solid white",
                    writingMode: "vertical-lr",
                    height: "50px",
                  }}
                ></div>
                <button
                  onClick={handleShowCourt}
                  className="submit-btn"
                  disabled={dateSelected === null || checkingAvailability}
                >
                  <span className="flex items-center gap-2 justify-center">
                    CHECK AVAILABILITY
                    {checkingAvailability && (
                      <ProgressSpinner style={{ width: "16px", height: "16px" }} strokeWidth="4" />
                    )}
                  </span>
                </button>
              </div>
            </div>
          </div>
          {/* reponsive design */}
          <div className="responsive-form-style form-style">
            <div 
            style={{ display: "flex", justifyContent: "center" }}
            >
              BOOK A SLOT
            </div>

            <div
              className="responsive-first-row"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <div
                className="slot-border monthselecter"
              >
                <Calendar
                  ref={calendarRef}
                  value={selectdate}
                  onChange={(e) => calanderChange(e)}
                  dateFormat="M dd yy"
                  minDate={new Date()}
                  readOnlyInput
                  placeholder={localStringValue}
                  style={{
                    width: "100%",
                  }}
                  showIcon
                />
              </div>

              <div className="slot-border">
                <div 
                style={{ display: "flex", alignItems: "center", width:'100%', justifyContent:'space-between'}}
                >
                  <div>
                  PLAYER COUNT
                  </div>
                  <div style={{display:'flex'}}>
                  <InputNumber
                      value={playerCount}
                      onValueChange={(e) => setPlayerCount(e.value)}
                      mode="decimal"
                      min={min}
                      max={max}
                      style={{width:'30px'}}
                    />
                    <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <MdArrowDropUp
                      size={25}
                      style={{ cursor: "pointer" }}
                      onClick={handleIncrement}
                    />
                    <MdArrowDropDown
                      size={25}
                      style={{ marginTop: "-10px", cursor: "pointer" }}
                      onClick={handleDecrement}
                    />
                  </span>
                  </div>
                </div>
              </div>
            </div>

  <div className="responsive-second-row" style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                onClick={() => {
                  setDateselected(0);
                  const d = new Date(date);
                  d.setDate(d.getDate() + 0);
                  setSelectDate(d);
                }}
                className={`date-border1 ${
                  dateSelected === 0 ? "dateSelected" : ""
                }`}
              >
                {getDayAndDate(date, 0)}
              </div>
                <button
                  onClick={handleShowCourt}
                  className="submit-btn"
                  disabled={dateSelected === null || checkingAvailability}
                >
                  <span className="flex items-center gap-2 justify-center">
                    CHECK AVAILABILITY
                    {checkingAvailability && (
                      <ProgressSpinner style={{ width: "16px", height: "16px" }} strokeWidth="4" />
                    )}
                  </span>
                </button>
            </div>
          </div>
        </div>
          <div
            className="available-slot"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <div
              style={{
                width: "90%",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >

              <div className="flex flex-wrap gap-5 my-6">
                {court.map((courtDetails)=>(
                  <div key={courtDetails.id}>
                    {courtDetails.courts?.filter(c => c.courtStatus !== "blocked")?.sort((a, b) => a.courtId - b.courtId).map((courtid)=>{
                    const sortedSlots = getSortedSlotsForCourt(courtid.courtId);

                    console.log(sortedSlots)
                      return(
                      <div key={courtid.courtId}>
                        <p className="flex">Court {courtid.courtId}  
                        <small className="font-[LeagueSpartan] text-sm flex items-center"> <BsDot size={25} className="text-[orange] font-thin"/> (available slot)</small> </p>
                       <div className="flex flex-wrap gap-3 py-7" >
                        {sortedSlots.map(([key,slot], i)=> {
  const next = sortedSlots[i + 1]?.[1]?.time || "12:00AM";
  const isBooked = slot.status === "booked";
  const isBulkBooked = slot.status === "bulk_booked";
  const isDisabled = isSlotDisabled(courtid.courtId, slot.time);
  const isSelected = isSlotSelected(courtid.courtId, slot.time);
  const isInAvailableRange = isSlotInAvailableRange(courtid.courtId, slot.time);
  const isStart = isStartSlot(courtid.courtId, slot.time);
  
  return (
   <p
    key={key}
    onClick={() => {
      if (!isBooked && !isBulkBooked && !isDisabled) {
        handleSelectSlot(courtid.courtId, slot.time);
      }
    }}
    className={`slot-border ${slot.status} ${
      isBooked || isBulkBooked || isDisabled
        ? "booked-slot cursor-not-allowed opacity-50" 
        : "available-slot cursor-pointer"
    } ${
      isSelected ? "selected-slot bg-orange-100 text-[#4EF520]" : ""
    } ${
      isInAvailableRange && !isSelected ? "available-range bg-[#63F5204F]" : ""
    } ${
      isStart ? "start-slot border-2 border-blue-500" : ""
    }`}
    style={{
      pointerEvents: (isBooked || isBulkBooked || isDisabled) ? 'none' : 'auto'
    }}
  >
    {slot.time} - {next}
  </p>
  )
})}
                        <button 
                          onClick={() => handleBookSlot(courtid.courtId)}
                          disabled={selectedSlots.filter(slot => slot.courtId === courtid.courtId).length === 0}
                          className="submit-btn uppercase"
                          style={{
                            minWidth: '220px'
                          }}
                        >
                          Book Slot
                        </button>
                        </div>
                      </div>
                    )})}
                  </div>
                ))}
              </div>
            </div>
          </div>
        <Footer />
      </div>

      {selectedCourt && (
        <div className="overlay">
          <ConfirmBook
            selectedDate={formatDate(selectdate) || currentDate}
            courtNumber={String(selectedCourt)}
            startTime={startTime}
            endTime={nextTime}
            slotPrice={calculateSlotPrice(
              startTime,
              nextTime,
              priceDetails
            )}
            playerCount={playerCount}
            onBookingSuccess={handleShowCourt}
            onClose={() => {
              setSelectedCourt(false);
              setSelectedSlots([]);
              setRangeSelection({
                courtId: null,
                startSlotIndex: null,
                startTime: null,
                availableSlots: []
              });
            }}
            clearBookingState={resetBookingState}
          />
        </div>
      )}
    </div>
  );
};

export default SlotPage;
